export interface ViewAcl {
  canCreate: boolean
  canDelete: boolean
  canUpdate: boolean
  canManageBin: boolean
  canActivate: boolean
  canDeactivate: boolean
  sensitiveFields: string[]
  invisibleFields: string[]
  loggingEnabled: boolean
}

export const VIEW_ACL_DEFAULT: ViewAcl = {
  canCreate: false,
  canDelete: false,
  canUpdate: false,
  canManageBin: false,
  canActivate: false,
  canDeactivate: false,
  sensitiveFields: [],
  invisibleFields: [],
  loggingEnabled: false,
}
